import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QueueHistoryInfoModel } from '@core/services/work-queue/work-queue.model';
import { CommonModule } from "@angular/common";

@Component({
  selector: 'Teranet-QueueHistoryDialog',
  templateUrl: './queue-history-dialog.component.html'
})
export class QueueHistoryDialogComponent implements OnInit {

  queueHistoryInfo: any[];

  constructor(
    public dialogRef: MatDialogRef<QueueHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: QueueHistoryInfoModel[]
  ) { }

  ngOnInit() {
    this.queueHistoryInfo = this.data;
  }

  onClick(): void {
    this.dialogRef.close();
  }
}
